import type { Assistant } from "../types";

export const ASSISTANT_LOCKED = "assistant_locked";

/** `name` comes from data (see assistantName); never a literal. */
export const lockedMessage = (
  assistant: Pick<Assistant, "unlockAfterMissions" | "filedMissions">,
  name: string,
) =>
  `Complete ${assistant.unlockAfterMissions} missions to unlock ${name} (${assistant.filedMissions}/${assistant.unlockAfterMissions})`;

export const lockedAssistant = (
  assistants: Assistant[] | undefined,
  memberId: string,
) =>
  assistants?.find(
    (assistant) => assistant.memberId === memberId && assistant.locked,
  );
